// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-button.start .task-button.stop[data-v-23f44bfe] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
